<template>
  <div class="home">
    <el-card
      shadow="hover"
      @click="handleGoTz"
    >
      <el-link :underline="false" style="width:100%;height:100%" @click="handleGoTz">
        铁 柱 计 算 器
      </el-link>
    </el-card>
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    // HelloWorld
  },
  methods: {
    handleGoTz() {
      console.log('1')
      this.$router.push('/tools/tz_calculator')
    }
  }
}
</script>
